































import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import { ElUploadInternalFileDetail } from '@/typings/files'
import { uploadImgUrl } from '@/api/upload'
import { AppModule } from '@/store/modules/app'
type imgType = 1 | 2 | 3 | 4 | 5 | 6 | 7
const imgCheckList = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif']

@Component({
  name: 'single-photo'
})
export default class extends Vue {
  @Prop({ required: true }) imgType!: imgType // 图片类型
  @Prop({ type: String }) firstImg!: string // 首次展示
  @Prop({ type: String }) text!: string
  @Prop({ default: () => ({ '--width': '146px', '--height': '146px' }) }) styles!: any
  @Prop({ type: Number }) noCompress!: number
  @PropSync('icon', { required: true }) iconPath!: string // 图片相对路径

  uploadImgUrl = uploadImgUrl
  public imageUrl: string = ''
  customColors: any[] = [
    { color: 'rgba(223,228,237,0.10)', percentage: 0 },
    { color: '#00AEEC', percentage: 100 }
  ]
  progressPercent: number = 0
  timer: any = null

  // life
  created() {
    // this.imageUrl = this.iconPath
  }
  mounted() {
    this.$nextTick(() => {
      this.imageUrl = this.iconPath
    })
  }
  get disabled() {
    return AppModule.uploadDisabled
  }
  handleProgress() {
    if (this.progressPercent < 99) {
      this.timer = setTimeout(() => {
        this.progressPercent++
        this.handleProgress()
      }, 100)
    }
  }
  // methods
  beforeAvatarUpload(file: ElUploadInternalFileDetail) {
    console.log(file.type)
    const isJPG = imgCheckList.includes(file.type)
    const isLt500K = file.size / 1024 / 1024 < 5

    if (!isJPG) {
      this['$message'].error('上传图片只能是JPG,PNG,JEPG 格式!')
    }
    if (!isLt500K) {
      this['$message'].error('上传图片大小不能超过 5M!')
    }
    if (isJPG && isLt500K) {
      this.$emit('fileSize', file.size)
      AppModule.SetUploadDisabled(true)
      // 如果可以上传则禁止上传新的图片
      this.handleProgress()
    }
    return isJPG && isLt500K
  }
  handleAvatarSuccess(res: any, file: ElUploadInternalFileDetail) {
    this.imageUrl = URL.createObjectURL(file.raw)
    if (res.status.code === 0) {
      this.iconPath = res.data
      this['$message'].success('图片上传成功!')
      this.progressPercent = 100
    } else {
      this.iconPath = ''
      this['$message'].error(res.status.message)
      this.progressPercent = 0
    }
    AppModule.SetUploadDisabled(false)
    this.progressPercent = 0
    clearTimeout(this.timer)
    this.timer = null
  }
  handleError() {
    this['$message'].error('图片上传失败!')
    AppModule.SetUploadDisabled(false)
  }
  @Watch('iconPath')
  onImageUrlChanged(val: string, oldVal: string) {
    // 不为空
    if (val) {
      if (val.includes('https://pics.tutuapp.com')) {
        this.imageUrl = val
      } else {
        this.imageUrl = `https://pics.tutuapp.com/${val}`
      }
    } else {
      this.imageUrl = val
    }
  }
}
